<template>
    <div class="systemTree-main">
        <div class="systemTree">
        <div class="systemTree_header">
            <div class="header-name">
                <div class="header-icon">
                    <inline-svg v-if="currentTree.iconUrl" :src="`${apiImg}${currentTree.iconUrl}`" />
                </div>
                <div class="header-txt">
                    <p>{{ currentTree.name }}</p>
                    <a @click.prevent="getNode(currentTree.id, currentTree.name, false)">Перейти в описание </a>
                </div>
            </div>
            <div class="header-btn">
                <button @click.prevent="$router.push('/lkstudents/training')">К списку систем организма</button>
                <!-- <button>Пройти тест</button> -->
            </div>
        </div>
        <div class="systemTree_body">
            <div class="body_name">
                <p @click="$router.push('/lkstudents/training')">Системы организма</p>

                <div class="breadcrumbs ml-2" v-for="(item, key) in breadCrumbs" :key="'F'+key">
                    <inline-svg :src="require('../../../assets/img/icons/breadCrumbs.svg')" />
                    <p @click="key !== breadCrumbs.length-1 ? transitionLvl(item.nodeId) : ''">{{ item.name }}</p>
                </div>
            </div>
            <div class="body-container">
                <v-skeleton-loader v-for="key in 6" :key="'A'+key" width="252" height="258" type="card" v-show="loadingTree"/>

                <div class="body-item" v-for="(item, idx) in currentTree.children" :key="'B'+idx" v-show="!loadingTree">
                    <img class="contain-img" v-if="item.imageUrl" :src="`${apiImg}${item.imageUrl}`" width="254" height="174" style="margin-top: 20px;" alt="image">
                    <div class="item-txt">
                        <p>{{ item.name }}</p>
                        <button @click="getNode(item.id, item.name, false)" :disabled="!item.isContentExist" :class="{'disabledBtn': !item.isContentExist}" >
                            Посмотреть информацию

                            <v-overlay absolute :value="loadGetNode">
                                <v-progress-circular indeterminate size="24" />
                            </v-overlay>
                        </button>
                        <button @click="transitionLvl(item.id)" :disabled="!item.isChildrenExist" :class="{'disabledBtn': !item.isChildrenExist}">Перейти к дереву знаний</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="clickShow" class="nodeItem">
            <div class="nodeItem-container" :style="'height:' + clientH +'px'">
                <button class="close" @click.prevent="clickShow = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="nodeItem_body" :style="'height:' + (clientH-37) +'px'">
                    <div v-if="tab === 0" class="body_left">
                        <div class="name-txt" :class="{'closeLeft': close}">
                            <p>{{ currentNode.name }}</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click.prevent="close = !close">
                                <path d="M11 18L5 12L11 6" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19 18L13 12L19 6" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="chapter-wrap">
                            <div class="chapter" :class="{'closeLeftChapter': close}">
                                <p>Разделы</p>
                                <div class="chapter-container">
                                    <a
                                        v-for="(item, ind) in headList"
                                        :key="'C'+ind"
                                        :style="item.class === 'h1' ? '' : 'margin-left: 25px'"
                                        :class="{'active': currentHref === item.href}"
                                        @click.prevent="currentHref !== item.href ? scrollToID(item.href, false) : ''"
                                    >
                                        {{ item.text }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="body_right_block">
                        <div v-if="tab === 1 || tab === 2" class="name-txt">
                            <p>{{ currentNode.name }}</p>
                        </div>

                        <v-tabs v-model="tab">
                            <v-btn-toggle
                                v-model="tab"
                                group
                                mandatory
                            >
                                <v-btn :value="0">Описание</v-btn>
                                <v-btn v-if="viewNorma" :value="1">Норма</v-btn>
                                <v-btn v-if="viewPatalogy" :value="2">Патология</v-btn>
                            </v-btn-toggle>
                            <v-tabs-items v-model="tab">
                                <v-tab-item>
                                    <div class="body_right ql-editor" :style="`height: ${clientH-150}px!important`" ref="bodyRight" v-html="currentNode.content" />
                                </v-tab-item>
                                <v-tab-item>
                                    <desktopView :items="isNormalFiles" :load="load" class="body_right" :style="`height: ${clientH - 150}px;`" />
                                </v-tab-item>
                                <v-tab-item>
                                    <desktopView :items="isPatalogyFiles" :load="load" class="body_right" :style="`height: ${clientH - 150}px;`" />
                                </v-tab-item>
                            </v-tabs-items>
                        </v-tabs>
                    </div>
                </div>
            </div>
        </div>
        </div>

        <div class="system-tree-mobile">
            <div class="systemTree-header-mobile">
            <div class="header-name-mobile">
                <div class="header-icon-mobile">
                    <inline-svg class="svg" v-if="currentTree.iconUrl" :src="`${apiImg}${currentTree.iconUrl}`" />
                </div>
                <div class="header-txt-mobile">
                    <p class="">{{ currentTree.name }}</p>
                    <a @click.prevent="getNode(currentTree.id, currentTree.name, true)">Перейти в описание </a>
                </div>
            </div>
            <div class="header-btn-mobile">
                <button class="button-list" @click.prevent="$router.push('/lkstudents/training')">К списку систем организма</button>
                <button v-if="levelSystem > 1" @click="transitionLvl(breadCrumbs[breadCrumbs.length-2].nodeId)" class="button-list">Назад</button>
                <!-- <button class="button-test">Пройти тест</button> -->
            </div>
        </div>
        <div v-show="!loadingTree" class="systemTree_body-mobile">
            <div v-for="(item, idx) in currentTree.children" :key="'B'+idx" class="body-item-mobile">
                <img v-if="item.imageUrl" class="contain-img-mobile" :src="`${apiImg}${item.imageUrl}`" width="300" height="300" style=" margin-top: 10px;" alt="image">
                <div class="item-txt-mobile">
                    <p class="title-info">{{ item.name }}</p>
                    <div class="body-btn-mobile">
                        <button @click="getNode(item.id, item.name, true)" :disabled="!item.isContentExist" :class="{'disabledBtn': !item.isContentExist}" class="button-info">Посмотреть информацию</button>
                        <button @click="transitionLvl(item.id)" :disabled="!item.isChildrenExist" :class="{'disabledBtn': !item.isChildrenExist}" class="button-tree">Перейти к дереву знаний</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="clickShow" class="node-item-mobile">
            <div class="node-item-container-mobile">
                <div class="node-item-body-mobile">
                    <button class="close-mobile" @click.prevent="clickShow = false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <div class="name-txt-mobile" :class="{'closeLeft': close}">
                        <p>{{ currentNode.name }}</p>
                    </div>

                    <v-tabs v-model="tab">
                        <v-btn-toggle
                            v-model="tab"
                            group
                            mandatory
                        >
                            <v-btn :value="0">Описание</v-btn>
                            <v-btn v-if="viewNorma" :value="1">Норма</v-btn>
                            <v-btn v-if="viewPatalogy" :value="2">Патология</v-btn>
                        </v-btn-toggle>
                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <div class="chapter-wrap-mobile">
                                    <div class="chapter-mobile" :class="{'closeLeftChapter': close}">
                                        <v-menu offset-y :close-on-content-click="true" >
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" class="d-flex justify-space-between align-center" style="width: 100%; height: 40px; border: 2px solid rgb(189, 185, 185); border-radius: 5px;">
                                                    <span style="margin-left: 10px;">Разделы</span>
                                                        <v-icon @click="isOpen = !isOpen" >
                                                            {{ 'mdi-chevron-down' }}
                                                        </v-icon>
                                                    </div>
                                            </template>

                                            <v-list class="d-flex flex-column" >
                                                <v-list-item
                                                    v-for="(item, index) in headList"
                                                    :key="index"
                                                    @click.prevent="currentHref !== item.href ? scrollToID(item.href, true) : ''"
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ item.text }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </div>
                                <div class="body-right" ref="bodyRightM" v-html="currentNode.content" :style="`height: ${clientH - 260}px;`" />
                            </v-tab-item>
                            <v-tab-item>
                                <mobileView :rows="isNormalFiles" :load="load" class="body-right" :style="`height: ${clientH - 210}px;`" />
                            </v-tab-item>
                            <v-tab-item>
                                <mobileView :rows="isPatalogyFiles" :load="load" class="body-right" :style="`height: ${clientH - 210}px;`" />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </div>
            </div>
        </div>
        </div>

        <vue-easy-lightbox moveDisabled :visible="visible" :imgs="srcImg" :index="index" @hide="closetViewPhoto('visible')" />
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import desktopView from './indicators/desktopView.vue'
import mobileView from './indicators/mobileView.vue'
import InlineSvg from 'vue-inline-svg';
import './index.scss';
import 'quill/dist/quill.core.css';

export default {
    name: 'SystemTree',
    components: {
        InlineSvg,
        desktopView,
        mobileView
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            apiImg: 'apiImg'
        })
    },
    data() {
        return {
            isNormalFiles: [],
            isPatalogyFiles: [],
            viewNorma: false,
            viewPatalogy: false,
            load: false,
            tab: null,
            visible: false,
            srcImg: [],
            index: null,
            breadCrumbs: [],
            currentHref: null,
            headList: [],
            isOpen: false,
            test: ['Fizz', 'Buzz'],
            content: [],
            levelSystem: 1,
            loadGetNode: false,
            loadingTree: false,
            scrollId:null,
            clientH: null,
            close: false,
            clickShow: false,
            mobile: false,
            currentTree: {
                children: [],
                humanId: '',
                iconUrl: '',
                name: '',
            },
            currentNode: {
                id: '',
                name: '',
                content: ''
            }
        }
    },
    watch: {
		tab(val) {
			if (val === 1 && this.isNormalFiles.length === 0) this.getDataTable(true);
			if (val === 2 && this.isPatalogyFiles.length === 0) this.getDataTable(false);
		}
	},
    methods: {
		...mapActions({
            getPropertyFiles: "property/getPropertyFiles",
		}),
        clickPhoto(e, url) {
            this.srcImg = [];
            this.srcImg.push({src: url});
            this.visible = true
            this.index = e
        },
        closetViewPhoto(name) {
            this[name] = false
			this.index = null
            this.srcImg = [];
        },
        getNode(id, name, mobile) {
            this.tab = 0;
            this.loadGetNode = true;

            this.$http.get(`${this.apiUrl}BodyTree/GetNode?nodeid=${id}&withMediaFiles=true`)
                .then((res) => {
                    if (res.data.content) {
                        this.currentNode.content = res.data.content;

                        this.$nextTick(() => {
                            this.headList = []

                            let content = document.querySelector(`${mobile ? '.body-right' : '.ql-editor'}`);

                            content.querySelectorAll('h1, h2, img').forEach((item, index) => {
                                if (item.localName == 'img') {
                                    item.addEventListener('click', () => {
                                        this.clickPhoto(index, item.getAttribute('src'));
                                    });
                                } else if (item.innerText) {
                                    item.id = `h-${index}`
                                    this.headList.push({ href: item.id, text: item.innerText, class: item.localName })
                                }
                            });

                            this.loadGetNode = false;
                            this.currentNode.id = id
                            this.currentNode.name = name
                            this.clickShow = true;
                            this.viewNorma = res.data.isNormalPropertyExist;
                            this.viewPatalogy = res.data.isNotNormalPropertyExist;
                            this.isNormalFiles = [];
                            this.isPatalogyFiles = [];

                            this.$nextTick(() => {
                                this.$refs[`${mobile ? 'bodyRightM' : 'bodyRight' }`].scrollTop = 0;
                            });
                        })
                    }
                });
        },
        get(id) {
            this.loadingTree = true;
            this.$http.get(`${this.apiUrl}BodyTree/GetBodyTreeBreadcrumbsByNodeId?nodeid=${id}`)
                .then((resBreadcrumbs) => {
                    resBreadcrumbs.data.shift();
                    this.levelSystem = resBreadcrumbs.data.length
                    this.breadCrumbs = resBreadcrumbs.data;

                    this.$http.get(`${this.apiUrl}BodyTree/GetTreeViewByNodeId?nodeid=${id}`)
                    .then((res) => {
                        if(res.data && res.data.children && res.data.children.length > 0) {
                            res.data.children = res.data.children.sort((a,b) => a.sortOrder - b.sortOrder);
                        }
                        this.currentTree = res.data
                        this.loadingTree = false;
                    })
                    .catch((error) => {
                        if(error) {
                            this.loadingTree = false;
                        }
                    })
                })
                .catch((error) => {
                    if(error) {
                        this.loadingTree = false;
                    }
                })
        },
        scrollToID(id, mobile) {
            this.currentHref = id;

            this.$refs[`${mobile ? 'bodyRightM' : 'bodyRight' }`].scrollTop = 0;

            let outerOffset = mobile ? 228 : 145;
            let topOffset = document.getElementById(`${id}`).getBoundingClientRect().top - outerOffset;
            if (topOffset < 0) topOffset = 0;

            this.$refs[`${mobile ? 'bodyRightM' : 'bodyRight' }`].scrollTo({
                top: topOffset,
                left: 0,
                behavior: 'smooth'
            });
        },
        transitionLvl(id) {
            this.get(id);
            this.$router.replace({ name: 'SystemTree', params: { id: id } });
        },
        getDataTable(isNorma) {
            this.load = true;

            this.$http.get(`${this.apiUrl}Property/GetByNode?nodeid=${this.currentNode.id}&isnormal=${isNorma}`)
                .then((res) => {
                    res.data.forEach(x => {
                        x.propertyMediaLinks.forEach(y => {
                            y.file = y.mediaFile;
                        });
                    });

                    if (isNorma) this.isNormalFiles = res.data;
                    else if (!isNorma) this.isPatalogyFiles = res.data;
                    this.load = false;
                });
        }
    },
    created() {
        this.clientH = window.innerHeight;
        this.get(this.$route.params.id);
    }
}
</script>

<style scoped>
    .v-menu__content .v-list .v-list-item .v-list-item__content .v-list-item__title {
        white-space: normal;
    }
</style>